import { CxmRulesClientProvider } from './provider';
/**
 * Singleton instance of the [[CxmRulesClientProvider]]. Use via `cxmRulesClient.instance`.
 */
export const cxmRulesClient = new CxmRulesClientProvider();
//# sourceMappingURL=client.js.map